import { Entity, Column, PrimaryGeneratedColumn, CreateDateColumn, UpdateDateColumn, VersionColumn } from 'typeorm';
@Entity('sub_category')
export class SubCategory {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id : number ;

    // @Column('varchar',{
    //     name: 'category_id'
    // })
    // categoryId:string;

    @Column('varchar',{
        name: 'category_id'
    })
    categoryId:number;

    @Column('varchar',{
        name: 'sub_category_name'
    })
    subCategoryName:string;
    

    @Column('varchar',{
        name: 'uom'
    })
    uom:string;
    
    @Column('varchar',{
        name: 'created_user'
    })
    createdUser:string;

    @Column('varchar',{
        name: 'updated_user'
    })
    updatedUser:string;

    @Column('varchar',{
        name: 'client_code'
    })
    clientCode:string;

    @Column('varchar',{
        name: 'client_id'
    })
    clientId:number;

    @Column('varchar',{
        name: 'division_code'
    })
    divisionCode:string;

    @Column('int',{
        name: 'division_id'
    })
    divisionId:number;

    @CreateDateColumn({ name: 'created_at' })
    createdAt: Date

    @UpdateDateColumn({ name: 'updated_at' })
    updatedAt: Date

}